
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("1To13", function(module, exports) {
"use strict";
var $160d8e908836def1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArrowLeft = void 0;

const $160d8e908836def1$var$react_1 = $160d8e908836def1$var$__importDefault((parcelRequire("acw62")));
const $160d8e908836def1$var$ArrowLeft = ({ fill: fill = "none" })=>{
    if (fill === "filled") return $160d8e908836def1$var$react_1.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        width: "100%",
        height: "100%",
        viewBox: "0 0 256 256"
    }, $160d8e908836def1$var$react_1.default.createElement("path", {
        d: "M224 128a8 8 0 0 1-8 8h-96v64a8 8 0 0 1-13.66 5.66l-72-72a8 8 0 0 1 0-11.32l72-72A8 8 0 0 1 120 56v64h96a8 8 0 0 1 8 8"
    }));
    return $160d8e908836def1$var$react_1.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "currentColor",
        viewBox: "0 0 256 256"
    }, $160d8e908836def1$var$react_1.default.createElement("path", {
        d: "M224 128a8 8 0 0 1-8 8H59.31l58.35 58.34a8 8 0 0 1-11.32 11.32l-72-72a8 8 0 0 1 0-11.32l72-72a8 8 0 0 1 11.32 11.32L59.31 120H216a8 8 0 0 1 8 8"
    }));
};
module.exports.ArrowLeft = $160d8e908836def1$var$ArrowLeft;

});


//# sourceMappingURL=arrow-left.708bc56d.js.map
